import { render } from "./HeroMap.vue?vue&type=template&id=0ffaa23b&ts=true"
import script from "./HeroMap.vue?vue&type=script&lang=ts"
export * from "./HeroMap.vue?vue&type=script&lang=ts"

import "./HeroMap.vue?vue&type=style&index=0&id=0ffaa23b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__